import React from "react"

export const SearchLink = ({ item, setCurrentRefinement }) => {
  //TODO: For later use, item prop also contains a filter key
  const { searchString } = item

  return searchString ? (
    <button
      className="luna-nav-search__recent-and-common-searches--search-link"
      onClick={() => setCurrentRefinement(searchString)}
      tabIndex={0}
    >
      {searchString}
    </button>
  ) : null
}

export default SearchLink
